// extracted by mini-css-extract-plugin
export default {"partnersTableContainer":"PartnersUserTable_partnersTableContainer__SMUgi","buttons":"PartnersUserTable_buttons__jSSQn","tables":"PartnersUserTable_tables__zOzrz"};